export const AddIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path id="Samenstellen-icon"
              d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm4,13H13v3a1,1,0,0,1-2,0V13H8a1,1,0,0,1,0-2h3V8a1,1,0,0,1,2,0v3h3a1,1,0,0,1,0,2Z"/>
    </svg>
)